import { PlayPermissionTypes } from '../../auth/authEnums';
import {
  EpisodeAccessType,
  InternetProvider,
  LiveChannelAccessType,
} from '../../graphql/api.generated';

export const getPlayButtonData = (
  hasPermission: boolean,
  status: PlayPermissionTypes,
  episodeUid?: string,
  programUid?: string,
  ispLabel?: string,
) => {
  const labels = {
    [PlayPermissionTypes.FREE_CONTENT]: {
      label: 'تماشا',
      link: `/w/${episodeUid}`,
    },
    [PlayPermissionTypes.FREE_ISP]: {
      label: 'تماشا',
      link: `/w/${episodeUid}`,
    },
    [PlayPermissionTypes.SUBSCRIBED_USER]: {
      label: 'تماشا',
      link: `/w/${episodeUid}`,
    },
    [PlayPermissionTypes.ONLINE_SCREENING_TICKET]: {
      label: 'تماشا',
      link: `/w/${episodeUid}`,
    },

    [PlayPermissionTypes.SUBSCRIPTION_REQUIRED]: {
      label: 'خرید اشتراک',
      link: `/subscription?ru=/p/${programUid}`,
    },
    [PlayPermissionTypes.ONLINE_SCREENING_TICKET_REQUIRED]: {
      label: 'خرید بلیط',
      link: `/ticket/${programUid}?ru=/p/${programUid}`, //TODO: provide appropriate online screening program id
    },
    [PlayPermissionTypes.LOGIN_REQUIRED]: {
      label: 'ورود و تماشا',
      link: `/login?ru=/p/${programUid}`,
    },
    [PlayPermissionTypes.CONTENT_NOT_READY]: {
      label: 'به‌زودی',
      link: '#',
    },
    [PlayPermissionTypes.LOADING]: {
      label: 'در حال بارگذاری',
      link: '#',
    },
    [PlayPermissionTypes.IRAN_ACCESS]: {
      label: 'این محتوا در لوکیشن شما در دسترس نیست.',
      link: '#',
    },
    [PlayPermissionTypes.SUB_REQ_AND_DATA_CONTRACT]: {
      label: hasPermission ? `تماشای رایگان ${ispLabel ?? ''}` : 'خرید اشتراک',
      link: hasPermission ? `/w/${episodeUid}` : `/subscription?ru=/p/${programUid}`,
    },
  };
  return labels[status];
};

export enum UserWatchStateEnum {
  FREE,
  SUBSCRIBED,
  DATA_CONTRACT,
}

export const userWatchState = (
  userHasSubscription: boolean,
  accessType: EpisodeAccessType | LiveChannelAccessType,
  ispName: string,
  whiteListedIsps: InternetProvider[],
): string => {
  const whiteListedNames = whiteListedIsps.map((isp) => isp.descriptor.toUpperCase());
  if (userHasSubscription) {
    return UserWatchStateEnum[UserWatchStateEnum.SUBSCRIBED];
  }
  if (
    accessType === EpisodeAccessType.SubReqAndDataContract &&
    whiteListedNames.includes(ispName.toUpperCase())
  ) {
    return UserWatchStateEnum[UserWatchStateEnum.DATA_CONTRACT];
  }
  return UserWatchStateEnum[UserWatchStateEnum.FREE];
};
